export const translations = {
  da: {
    // Common
    "app.tagline": "Cykling · Løb · Padel",
    "common.login": "Log ind",
    "common.logout": "Log ud",
    "common.register": "Opret konto",
    "common.email": "E-mail",
    "common.password": "Adgangskode",
    "common.name": "Navn",
    "common.save": "Gem",
    "common.saving": "Gemmer…",
    "common.cancel": "Annuller",
    "common.delete": "Slet",
    "common.loading": "Indlæser…",
    "common.all": "Alle",
    "common.continue_with_google": "Fortsæt med Google",
    "common.continue_with_apple": "Fortsæt med Apple",
    "common.or": "Eller",
    "common.distance": "Distance",
    "common.duration": "Varighed",
    "common.pace": "Tempo",
    "common.spots": "Pladser",
    "common.skill": "Niveau",
    "common.venue": "Sted",
    "common.skill_level": "Niveau",
    "common.visibility": "Synlighed",
    "common.full": "Fuld",
    "common.start": "Start",
    "common.end": "Slut",
    "common.public": "Offentlig",
    "common.private": "Privat",
    "common.coming_soon": "Kommer snart",
    "common.km": "km",
    "common.min": "min",

    // Nav
    "nav.home": "Hjem",
    "nav.explore": "Udforsk",
    "nav.create": "Opret",

    // Landing
    "landing.kicker": "Fællesskab · Cykling · Løb · Padel",
    "landing.hero1": "FIND DINE",
    "landing.hero2": "TRÆNINGS",
    "landing.hero3": "PARTNERE.",
    "landing.intro": "TeamFit matcher atleter på niveau, tempo og mål. Opret en session, tegn ruten på kortet, og saml et hold på sekunder.",
    "landing.cta_register": "Bliv medlem",
    "landing.cta_login": "Jeg har allerede en konto",
    "landing.cta_open": "Åbn app",
    "landing.get_started": "Kom i gang",
    "landing.feature1_title": "Ruter på kortet",
    "landing.feature1_text": "Vælg start og slut. Vi beregner distance, tempo og varighed for cykling, løb eller padel.",
    "landing.feature2_title": "Hold på dit niveau",
    "landing.feature2_text": "Fra begynder til elite — deltag kun i sessioner der passer dit niveau og dine mål.",
    "landing.feature3_title": "Live gruppe-chat",
    "landing.feature3_text": "WebSocket-chat per aktivitet — planer forsvinder ikke i private beskeder.",
    "landing.footer_motto": "Bevæg. Sammen.",
    "landing.download_kicker": "Hent appen",
    "landing.download_section_kicker": "TEAMFIT TIL IOS & ANDROID",
    "landing.download_section_title": "Hele oplevelsen i lommen.",
    "landing.download_section_body": "Webappen er nok til at komme i gang. Men det er på mobilen TeamFit virkelig kommer til live — live-position under sessioner, push-notifikationer når en ven inviterer dig, og hurtig opretelse af sessioner mens du er på farten.",
    "landing.download_perk1": "Live-position under sessioner",
    "landing.download_perk2": "Push-beskeder fra dit hold",
    "landing.download_perk3": "Hurtigere oprettelse — kort og GPS i appen",
    "landing.download_perk4": "Apple Sign-In og Google login",
    "landing.live_now": "Live nu",

    // Auth
    "auth.welcome_back": "Velkommen tilbage",
    "auth.welcome_sub": "Log ind og find dit træningshold.",
    "auth.create_title": "Opret din konto",
    "auth.create_sub": "Byg din atletprofil på under et minut.",
    "auth.move_together1": "BEVÆG.",
    "auth.move_together2": "SAMMEN.",
    "auth.new_to_teamfit": "Ny på TeamFit?",
    "auth.forgot_password_link": "Glemt din adgangskode?",
    "auth.have_account": "Har du allerede en konto?",
    "auth.create_account_link": "Opret konto",
    "auth.fullname": "Fulde navn",
    "auth.password_hint": "Adgangskode (min. 6 tegn)",
    "auth.login_action": "Log ind",
    "auth.create_action": "Opret konto",
    "auth.login_loading": "Logger ind…",
    "auth.create_loading": "Opretter…",
    "auth.coming_soon": "{provider}-login kommer snart — brug Google eller e-mail nu.",
    "auth.authenticating": "Logger ind…",

    // Dashboard
    "dashboard.kicker": "Dashboard",
    "dashboard.greeting": "HEJ, {name}.",
    "dashboard.intro": "Vælg en session nedenfor eller saml dit hold med en ny.",
    "dashboard.create_group": "OPRET GRUPPE",
    "dashboard.upcoming": "Kommende sessioner",
    "dashboard.popular": "Populære i nærheden",
    "dashboard.your_sessions": "Dine sessioner",
    "dashboard.view_all": "Se alle →",
    "dashboard.empty_upcoming": "Ingen kommende sessioner endnu — vær den første til at oprette en.",
    "dashboard.empty_popular": "Der er stille her. Opret den første aktivitet!",
    "dashboard.explore_label": "Udforsk",

    // My Activities
    "my_activities.title": "Mine aktiviteter",
    "my_activities.card.kicker": "Profil",
    "my_activities.tab.joined": "Tilmeldt",
    "my_activities.tab.hosted": "Mine sessioner",
    "my_activities.tab.completed": "Afsluttet",

    // Explore
    "explore.kicker": "Udforsk",
    "explore.title": "FIND EN SESSION.",
    "explore.all_levels": "Alle niveauer",
    "explore.no_match": "Ingen sessioner matcher — prøv et andet filter eller opret en.",
    "explore.near_me": "Nær mig",
    "explore.radius": "Radius",

    // Create
    "create.kicker": "Opret",
    "create.title": "SAML HOLDET.",
    "create.sport": "Sport",
    "create.title_field": "Titel",
    "create.title_placeholder": "fx. København → Roskilde solnedgangstur",
    "create.description": "Beskrivelse",
    "create.description_placeholder": "Tempo, ruteoplysninger, café-stop…",
    "create.datetime": "Dato & tid",
    "create.max_participants": "Maks. deltagere",
    "create.skill_level": "Niveau",
    "create.visibility": "Synlighed",
    "create.publish": "Udgiv session",
    "create.publishing": "Opretter…",
    "create.route_hint": "Rute · klik på kortet for at sætte punkter",
    "create.start": "Start",
    "create.end": "Slut",
    "create.my_location": "Min position",
    "create.need_start": "Vælg et startpunkt på kortet",
    "create.need_title": "Tilføj en titel",
    "create.created": "Session oprettet",

    // Activity Detail
    "activity.host_by": "Værtet af",
    "activity.no_desc": "Ingen beskrivelse angivet.",
    "activity.delete_action": "Slet",
    "activity.edit_action": "Rediger",
    "activity.leave_action": "Forlad",
    "activity.waitlisted_label": "På venteliste",
    "activity.join_action": "Deltag",
    "activity.join_waitlist": "Skriv mig på venteliste",
    "activity.confirm_delete": "Slet denne aktivitet?",
    "activity.joined": "Du er med.",
    "activity.waitlisted_toast": "Tilføjet venteliste",
    "activity.waitlisted_desc": "Vi rykker dig op, hvis en plads bliver ledig.",
    "activity.left": "Forlod sessionen",
    "activity.crew": "HOLD",
    "activity.waitlist": "Venteliste",
    "activity.chat_locked": "Chat låst",
    "activity.chat_locked_text": "Deltag i sessionen for at chatte med holdet.",
    "activity.host": "Vært",
    "activity.member": "Medlem",
    "activity.waiting": "Venter",
    "activity.live_location": "Live position",
    "activity.share_location": "Del min position",
    "activity.stop_sharing": "Stop deling",
    "activity.location_active": "Live deling aktiv",
    "activity.rate_now": "Vurder hold",

    // Rating modal
    "rating.title": "Hvordan var sessionen?",
    "rating.subtitle": "Vurder dine træningspartnere — det hjælper andre med at finde det rette hold.",
    "rating.submit": "Send vurderinger",
    "rating.skip": "Spring over",
    "rating.success": "Tak for din feedback!",
    "rating.stars": "stjerner",

    // Notifications
    "notif.kicker": "Notifikationer",
    "notif.title": "SIGNALER.",
    "notif.empty": "Alt er læst.",
    "notif.view": "Se →",

    // Profile
    "profile.kicker": "Profil",
    "profile.change": "Skift",
    "profile.age": "Alder",
    "profile.height": "Højde (cm)",
    "profile.weight": "Vægt (kg)",
    "profile.fitness_level": "Form-niveau",
    "profile.sports": "Sportsgrene du træner",
    "profile.goals": "Mål",
    "profile.goals_placeholder": "fx. Sub-4t maraton, 200km/uge på cykel",
    "profile.bio": "Bio",
    "profile.saved": "Profil gemt",
    "profile.avatar_updated": "Profilbillede opdateret",
    "profile.upload_failed": "Upload mislykkedes",
    "pwa.install_title": "Installer TeamFit",
    "pwa.install_body": "Tilføj appen til din startskærm for hurtig adgang, fuldskærm og notifikationer.",
    "pwa.install_cta": "Installer",
    "pwa.install_later": "Senere",
    "pwa.ios_hint": "Tryk på Del-knappen og vælg \"Føj til hjemmeskærm\".",
    "legal.back_home": "Til forsiden",
    "legal.last_updated": "Senest opdateret",
    "legal.privacy_kicker": "Privatliv",
    "legal.privacy_title": "Privatlivspolitik",
    "legal.terms_kicker": "Vilkår",
    "legal.terms_title": "Brugervilkår",
    "legal.cookies_kicker": "Cookies",
    "legal.cookies_title": "Cookiepolitik",
    "legal.support_kicker": "Support",
    "legal.support_title": "Vi er her for at hjælpe.",
    "legal.faq_kicker": "FAQ",
    "legal.faq_title": "Ofte stillede spørgsmål",
    "legal.contact_kicker": "Kontakt",
    "legal.contact_title": "Skriv til os.",
    "legal.nav_privacy": "Privatliv",
    "legal.nav_terms": "Vilkår",
    "legal.nav_cookies": "Cookies",
    "legal.nav_faq": "FAQ",
    "legal.nav_support": "Support",
    "legal.nav_contact": "Kontakt",
  },
  en: {
    "app.tagline": "Cycling · Running · Padel",
    "common.login": "Log in",
    "common.logout": "Log out",
    "common.register": "Sign up",
    "common.email": "Email",
    "common.password": "Password",
    "common.name": "Name",
    "common.save": "Save",
    "common.saving": "Saving…",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.loading": "Loading…",
    "common.all": "All",
    "common.continue_with_google": "Continue with Google",
    "common.continue_with_apple": "Continue with Apple",
    "common.or": "Or",
    "common.distance": "Distance",
    "common.duration": "Duration",
    "common.pace": "Pace",
    "common.spots": "Spots",
    "common.skill": "Skill",
    "common.venue": "Venue",
    "common.skill_level": "Skill",
    "common.visibility": "Visibility",
    "common.full": "Full",
    "common.start": "Start",
    "common.end": "End",
    "common.public": "Public",
    "common.private": "Private",
    "common.coming_soon": "Coming soon",
    "common.km": "km",
    "common.min": "min",

    "nav.home": "Home",
    "nav.explore": "Explore",
    "nav.create": "Create",

    "landing.kicker": "Community-Driven · Cycling · Running · Padel",
    "landing.hero1": "FIND YOUR",
    "landing.hero2": "TRAINING",
    "landing.hero3": "PARTNERS.",
    "landing.intro": "TeamFit matches athletes by level, pace and goals. Create a session, draw your route on the map, and rally a crew in seconds.",
    "landing.cta_register": "Join TeamFit",
    "landing.cta_login": "I already have an account",
    "landing.cta_open": "Open App",
    "landing.get_started": "Get Started",
    "landing.feature1_title": "Routes on the map",
    "landing.feature1_text": "Pick start and end. We calculate distance, pace and ETA for cycling, running or padel.",
    "landing.feature2_title": "Skill-matched crews",
    "landing.feature2_text": "Beginner to Elite — only join sessions that fit your level and goals.",
    "landing.feature3_title": "Live group chat",
    "landing.feature3_text": "WebSocket chat per activity so plans never get lost in DMs.",
    "landing.footer_motto": "Move. Together.",
    "landing.download_kicker": "Get the app",
    "landing.download_section_kicker": "TEAMFIT FOR IOS & ANDROID",
    "landing.download_section_title": "The full experience in your pocket.",
    "landing.download_section_body": "The web app is enough to get going. But TeamFit really comes alive on mobile — live location during sessions, push notifications when a friend invites you, and create a session in seconds while you're out the door.",
    "landing.download_perk1": "Live location during sessions",
    "landing.download_perk2": "Push notifications from your crew",
    "landing.download_perk3": "Faster create — map & GPS in-app",
    "landing.download_perk4": "Apple Sign-In and Google login",
    "landing.live_now": "Live now",

    "auth.welcome_back": "Welcome back",
    "auth.welcome_sub": "Log in to find your training crew.",
    "auth.create_title": "Create your account",
    "auth.create_sub": "Build your athlete profile in under a minute.",
    "auth.move_together1": "MOVE.",
    "auth.move_together2": "TOGETHER.",
    "auth.new_to_teamfit": "New to TeamFit?",
    "auth.forgot_password_link": "Forgot your password?",
    "auth.have_account": "Already a member?",
    "auth.create_account_link": "Create account",
    "auth.fullname": "Full name",
    "auth.password_hint": "Password (min 6)",
    "auth.login_action": "Log in",
    "auth.create_action": "Create account",
    "auth.login_loading": "Logging in…",
    "auth.create_loading": "Creating…",
    "auth.coming_soon": "{provider} login is coming soon — use Google or email for now.",
    "auth.authenticating": "Authenticating…",

    "dashboard.kicker": "Dashboard",
    "dashboard.greeting": "HEY, {name}.",
    "dashboard.intro": "Pick a session below or rally your crew with a new one.",
    "dashboard.create_group": "CREATE GROUP",
    "dashboard.upcoming": "Upcoming sessions",
    "dashboard.popular": "Popular near you",
    "dashboard.your_sessions": "Your sessions",
    "dashboard.view_all": "View all →",
    "dashboard.empty_upcoming": "No upcoming sessions yet — be the first to create one.",
    "dashboard.empty_popular": "It's quiet here. Create the first activity!",
    "dashboard.explore_label": "Explore",

    // My Activities
    "my_activities.title": "My activities",
    "my_activities.card.kicker": "Profile",
    "my_activities.tab.joined": "Joined",
    "my_activities.tab.hosted": "My sessions",
    "my_activities.tab.completed": "Completed",

    "explore.kicker": "Explore",
    "explore.title": "FIND A SESSION.",
    "explore.all_levels": "All levels",
    "explore.no_match": "No sessions match — try a different filter or create one.",
    "explore.near_me": "Near me",
    "explore.radius": "Radius",

    "create.kicker": "Create",
    "create.title": "RALLY THE CREW.",
    "create.sport": "Sport",
    "create.title_field": "Title",
    "create.title_placeholder": "e.g. Copenhagen → Roskilde sunset spin",
    "create.description": "Description",
    "create.description_placeholder": "Pace, route notes, café stops…",
    "create.datetime": "Date & time",
    "create.max_participants": "Max participants",
    "create.skill_level": "Skill level",
    "create.visibility": "Visibility",
    "create.publish": "Publish session",
    "create.publishing": "Creating…",
    "create.route_hint": "Route · click map to set points",
    "create.start": "Start",
    "create.end": "End",
    "create.my_location": "My location",
    "create.need_start": "Pick a start point on the map",
    "create.need_title": "Add a title",
    "create.created": "Session created",

    "activity.host_by": "Hosted by",
    "activity.no_desc": "No description provided.",
    "activity.delete_action": "Delete",
    "activity.edit_action": "Edit",
    "activity.leave_action": "Leave",
    "activity.waitlisted_label": "On waitlist",
    "activity.join_action": "Join session",
    "activity.join_waitlist": "Join waitlist",
    "activity.confirm_delete": "Delete this activity?",
    "activity.joined": "You're in.",
    "activity.waitlisted_toast": "Joined waitlist",
    "activity.waitlisted_desc": "We'll bump you up if a spot opens.",
    "activity.left": "Left the session",
    "activity.crew": "CREW",
    "activity.waitlist": "Waitlist",
    "activity.chat_locked": "Chat locked",
    "activity.chat_locked_text": "Join the session to chat with the crew.",
    "activity.host": "Host",
    "activity.member": "Member",
    "activity.waiting": "Waiting",
    "activity.live_location": "Live location",
    "activity.share_location": "Share my location",
    "activity.stop_sharing": "Stop sharing",
    "activity.location_active": "Live sharing active",
    "activity.rate_now": "Rate crew",

    "rating.title": "How was the session?",
    "rating.subtitle": "Rate your training partners — it helps others find the right crew.",
    "rating.submit": "Submit ratings",
    "rating.skip": "Skip",
    "rating.success": "Thanks for the feedback!",
    "rating.stars": "stars",

    "notif.kicker": "Notifications",
    "notif.title": "SIGNALS.",
    "notif.empty": "All caught up.",
    "notif.view": "View →",

    "profile.kicker": "Profile",
    "profile.change": "Change",
    "profile.age": "Age",
    "profile.height": "Height (cm)",
    "profile.weight": "Weight (kg)",
    "profile.fitness_level": "Fitness level",
    "profile.sports": "Sports you train",
    "profile.goals": "Goals",
    "profile.goals_placeholder": "e.g. Sub-4h marathon, ride 200km/week",
    "profile.bio": "Bio",
    "profile.saved": "Profile saved",
    "profile.avatar_updated": "Avatar updated",
    "profile.upload_failed": "Upload failed",
    "pwa.install_title": "Install TeamFit",
    "pwa.install_body": "Add the app to your home screen for quick access, fullscreen and notifications.",
    "pwa.install_cta": "Install",
    "pwa.install_later": "Later",
    "pwa.ios_hint": "Tap the Share button and choose \"Add to Home Screen\".",
    "legal.back_home": "Back home",
    "legal.last_updated": "Last updated",
    "legal.privacy_kicker": "Privacy",
    "legal.privacy_title": "Privacy Policy",
    "legal.terms_kicker": "Terms",
    "legal.terms_title": "Terms of Service",
    "legal.cookies_kicker": "Cookies",
    "legal.cookies_title": "Cookie Policy",
    "legal.support_kicker": "Support",
    "legal.support_title": "We're here to help.",
    "legal.faq_kicker": "FAQ",
    "legal.faq_title": "Frequently asked questions",
    "legal.contact_kicker": "Contact",
    "legal.contact_title": "Get in touch.",
    "legal.nav_privacy": "Privacy",
    "legal.nav_terms": "Terms",
    "legal.nav_cookies": "Cookies",
    "legal.nav_faq": "FAQ",
    "legal.nav_support": "Support",
    "legal.nav_contact": "Contact",
  },
};
